import type { Bundle } from '../types'

/** Portefeuille des marchands, import CSV, rapports de crawl. */
export const merchants = {
  // Portefeuille
  'merchants.title': { fr: 'Gestion des marchands', en: 'Merchant management' },
  'merchants.count': { fr: '{n} marchand(s)', en: '{n} merchant(s)' },
  'merchants.scanAll': { fr: 'Lancer scan N1', en: 'Run level-1 scan' },
  'merchants.scanning': { fr: 'Scan en cours…', en: 'Scan in progress…' },
  'merchants.addBtn': { fr: '+ Ajouter', en: '+ Add' },
  'merchants.importCsv': { fr: 'Import CSV', en: 'CSV import' },
  'merchants.searchPlaceholder': { fr: 'Rechercher par nom ou URL…', en: 'Search by name or URL…' },
  'merchants.allStatuses': { fr: 'Tous les statuts', en: 'All statuses' },
  'merchants.allCategories': { fr: 'Toutes catégories', en: 'All categories' },
  'merchants.empty': {
    fr: 'Aucun marchand enregistré. Cliquez sur « + Ajouter » ou « Import CSV ».',
    en: 'No merchant registered. Use “+ Add” or “CSV import”.',
  },
  'merchants.emptyFiltered': {
    fr: 'Aucun marchand ne correspond aux filtres.',
    en: 'No merchant matches the filters.',
  },
  'merchants.col.frequency': { fr: 'Fréq.', en: 'Freq.' },
  'merchants.col.lastCrawl': { fr: 'Dernier crawl', en: 'Last crawl' },
  'merchants.hours': { fr: '{n} h', en: '{n} h' },
  'merchants.scanOne': { fr: 'Scanner', en: 'Scan' },
  'merchants.scanOneTitle': { fr: 'Lancer un crawl', en: 'Run a crawl' },
  'merchants.suspend': { fr: 'Suspendre', en: 'Suspend' },
  'merchants.reactivate': { fr: 'Réactiver', en: 'Reactivate' },
  'merchants.scanFailedShort': { fr: 'Échec', en: 'Failed' },

  // Formulaire
  'merchants.formEdit': { fr: 'Modifier le marchand', en: 'Edit merchant' },
  'merchants.formNew': { fr: 'Nouveau marchand', en: 'New merchant' },
  'merchants.fieldName': { fr: 'Nom *', en: 'Name *' },
  'merchants.fieldUrl': { fr: 'URL *', en: 'URL *' },
  'merchants.fieldFrequency': { fr: 'Fréquence de crawl (heures)', en: 'Crawl frequency (hours)' },
  'merchants.namePlaceholder': { fr: 'Ex. : Orange Money SN', en: 'E.g. Orange Money SN' },
  'merchants.urlPlaceholder': { fr: 'Ex. : https://orange-money.sn', en: 'E.g. https://orange-money.sn' },
  'merchants.nameRequired': { fr: 'Le nom est requis', en: 'Name is required' },
  'merchants.urlRequired': { fr: "L'URL est requise", en: 'URL is required' },
  'merchants.update': { fr: 'Mettre à jour', en: 'Update' },

  // Messages
  'merchants.flashUpdated': { fr: '« {name} » mis à jour', en: '“{name}” updated' },
  'merchants.flashAdded': { fr: '« {name} » ajouté', en: '“{name}” added' },
  'merchants.flashSuspended': { fr: '« {name} » suspendu', en: '“{name}” suspended' },
  'merchants.flashReactivated': { fr: '« {name} » réactivé', en: '“{name}” reactivated' },
  'merchants.flashDeleted': { fr: '« {name} » supprimé', en: '“{name}” deleted' },
  'merchants.scanDone': { fr: 'Scan terminé : {n} marchand(s) analysé(s)', en: 'Scan complete: {n} merchant(s) analysed' },
  'merchants.scanOneDone': { fr: 'Scan terminé pour « {name} »', en: 'Scan complete for “{name}”' },
  'merchants.scanOneFailed': { fr: 'Scan échoué pour « {name} »', en: 'Scan failed for “{name}”' },
  'merchants.scanAllError': { fr: 'Erreur au lancement du scan N1', en: 'Could not start the level-1 scan' },
  'merchants.scanOneError': { fr: 'Erreur au lancement du crawl', en: 'Could not start the crawl' },

  // Progression du scan
  'merchants.progressDone': { fr: 'Scan terminé', en: 'Scan complete' },
  'merchants.progressRunning': {
    fr: 'Scan en cours : {done}/{total} marchand(s)',
    en: 'Scan in progress: {done}/{total} merchant(s)',
  },
  'merchants.progressCompleted': { fr: '{n} terminé(s)', en: '{n} completed' },
  'merchants.progressActive': { fr: '{n} en cours', en: '{n} running' },
  'merchants.progressFailed': { fr: '{n} échoué(s)', en: '{n} failed' },

  // Import CSV
  'merchants.importHelp': {
    fr: 'Format attendu : fichier CSV avec les colonnes <name> (ou nom), <url> (ou site), country (ou pays), category (ou categorie), crawlFrequencyHours (facultatif). Séparateur : virgule ou point-virgule.',
    en: 'Expected format: a CSV file with columns <name>, <url>, country, category and crawlFrequencyHours (optional). Separator: comma or semicolon.',
  },
  'merchants.importDrop': {
    fr: 'Glissez un fichier CSV ici ou cliquez pour parcourir',
    en: 'Drop a CSV file here, or click to browse',
  },
  'merchants.importFile': { fr: '{file} — {n} ligne(s)', en: '{file} — {n} row(s)' },
  'merchants.importTooShort': {
    fr: 'Le fichier CSV doit contenir au moins un en-tête et une ligne de données',
    en: 'The CSV file must contain a header row and at least one data row',
  },
  'merchants.importMissingCols': {
    fr: 'Colonnes obligatoires manquantes : « name » (ou « nom ») et « url » (ou « site »)',
    en: 'Required columns missing: “name” and “url”',
  },
  'merchants.importMore': { fr: '…et {n} autre(s) ligne(s)', en: '…and {n} more row(s)' },
  'merchants.importedCount': { fr: '{n} importé(s)', en: '{n} imported' },
  'merchants.importErrorCount': { fr: ', {n} erreur(s)', en: ', {n} error(s)' },
  'merchants.importRowError': { fr: 'Ligne {row} ({name}) : {error}', en: 'Row {row} ({name}): {error}' },
  'merchants.importSuccess': { fr: '{n} marchand(s) importé(s)', en: '{n} merchant(s) imported' },
  'merchants.importError': { fr: "Échec de l'import", en: 'Import failed' },
  'merchants.importSubmit': { fr: 'Importer {n} marchand(s)', en: 'Import {n} merchant(s)' },
  'merchants.importClear': { fr: 'Effacer', en: 'Clear' },
  'merchants.csvExample': { fr: 'Exemple CSV :', en: 'CSV example:' },

  // Rapports de crawl
  'reports.latest': { fr: 'Derniers rapports de crawl', en: 'Latest crawl reports' },
  'reports.allLevels': { fr: 'Tous niveaux', en: 'All levels' },
  'reports.allCountries': { fr: 'Tous pays', en: 'All countries' },
  'reports.sortRecent': { fr: 'Plus récent', en: 'Most recent' },
  'reports.sortScore': { fr: 'Score ↓', en: 'Score ↓' },
  'reports.col.level': { fr: 'Niveau', en: 'Level' },
  'reports.col.crawled': { fr: 'Crawlé', en: 'Crawled' },
  'reports.none': { fr: 'Aucun rapport trouvé', en: 'No report found' },
  'reports.viewDetail': { fr: 'Voir le détail', en: 'View details' },
  'reports.viewDetailOf': { fr: 'Voir le détail du rapport {name}', en: 'View details of report {name}' },
  'reports.resultCount': { fr: '{n} résultats', en: '{n} results' },

  // Détail d'un rapport
  'reportDetail.back': { fr: '← Retour à la liste', en: '← Back to list' },
  'reportDetail.error': { fr: 'Erreur : {error}', en: 'Error: {error}' },
  'reportDetail.sslValid': { fr: 'Valide', en: 'Valid' },
  'reportDetail.sslInvalid': { fr: 'Invalide', en: 'Invalid' },
  'reportDetail.responseTime': { fr: 'Temps de réponse', en: 'Response time' },
  'reportDetail.driftScore': { fr: 'Drift score', en: 'Drift score' },
  'reportDetail.scoresTitle': { fr: 'Scores détaillés', en: 'Score breakdown' },
  'reportDetail.availability': { fr: 'Disponibilité', en: 'Availability' },
  'reportDetail.regulatory': { fr: 'Réglementaire', en: 'Regulatory' },
  'reportDetail.vision': { fr: 'Vision IA', en: 'AI vision' },
  'reportDetail.aiTitle': { fr: 'Analyse Vision IA', en: 'AI vision analysis' },
  'reportDetail.reasonsTitle': { fr: 'Raisons du score', en: 'Reasons behind the score' },
  'reportDetail.keywordsTitle': { fr: 'Mots-clés paiement détectés', en: 'Payment keywords found' },
  'reportDetail.screenshotTitle': { fr: 'Capture d’écran', en: 'Screenshot' },
  'reportDetail.screenshotLink': {
    fr: 'Ouvrir la capture dans un nouvel onglet',
    en: 'Open the screenshot in a new tab',
  },
  'reportDetail.textTitle': { fr: 'Texte visible (extrait)', en: 'Visible text (extract)' },
} satisfies Bundle
